import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    Button,
    Typography,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useNavigate } from "react-router-dom";
import { IConvenioPagedResponse } from "models/response/convenio-paged-response";
import { PaginationResponse } from "models/pagination-response";

type ConveniosTableProps = {
    currentItems: PaginationResponse<IConvenioPagedResponse>;
};

export const ConveniosTable: React.FC<ConveniosTableProps> = ({ currentItems }) => {
    const navigate = useNavigate();

    if (!currentItems?.hasItems()) {
        return <Typography variant="body1">Nenhum convênio encontrado.</Typography>;
    }

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Nº Convênio</TableCell>
                        <TableCell>Concedente</TableCell>
                        <TableCell>Situação</TableCell>
                        <TableCell>Vigência Início</TableCell>
                        <TableCell>Vigência Fim</TableCell>
                        <TableCell align="right">Valor Convênio</TableCell>
                        <TableCell align="right">Valor Repassado</TableCell>
                        <TableCell align="center">Detalhes</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {currentItems.items.map((convenio) => (
                        <TableRow key={convenio.id}>
                            <TableCell>{convenio.numeroConvenio}</TableCell>
                            <TableCell>{convenio.nomConcedente}</TableCell>
                            <TableCell><Chip label={convenio.situacaoName} size="small" /></TableCell>
                            <TableCell>{new Date(convenio.dtaInicioVigencia).toLocaleDateString('pt-BR')}</TableCell>
                            <TableCell>{new Date(convenio.dtaFimVigencia).toLocaleDateString('pt-BR')}</TableCell>
                            <TableCell align="right">
                                {convenio.valorConvenio?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                            </TableCell>
                            <TableCell align="right">
                                {convenio.valorRepassado?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                            </TableCell>
                            <TableCell align="center">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<VisibilityIcon />}
                                    onClick={() => navigate(`/convenios/${convenio.id}`)}
                                >
                                    Detalhes
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
